/**
 * @author taulmax
 * @date 2024.10.26
 * @description 상품 카드 스켈레톤
 */
const SkeletonProductCard = () => {
  return (
    <div className="!bg-white !rounded-lg !overflow-hidden !border !border-gray-200 !cursor-default">
      <div className="!w-full !pt-[100%] !relative !overflow-hidden !bg-gradient-to-r !from-gray-200 !via-gray-100 !to-gray-200 !animate-pulse"></div>
      <div className="!p-4">
        <div className="!bg-gradient-to-r !from-gray-200 !via-gray-100 !to-gray-200 !animate-pulse !w-[70%] !h-6 !rounded !mb-3"></div>
        <div className="!bg-gradient-to-r !from-gray-200 !via-gray-100 !to-gray-200 !animate-pulse !w-[50%] !h-5 !rounded"></div>
      </div>
    </div>
  );
};

export default SkeletonProductCard;
